<style>

h1 {
    margin-bottom: 0px;
}

#controls {
    margin-top: 15px;
}

.user {
    color: #999;
    font-size: 12px;
}

/*Municipal*/
.badge {
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: rgb(123, 123, 123);
    cursor: pointer;
}

/*Special*/
.badge-special {
    padding: 5px;
    border-radius: 10px;
    color: grey;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: ghostwhite;
}

h3 {
    margin-bottom: 0px;
}

</style>

<script>
import {push} from './pt-router/Router.svelte'
import * as Common from './Common.js'
import Comments from './Comments.svelte'
import UserManagementView from './UserManagementView.svelte'
import FeedView from './FeedView.svelte'
import { onMount,afterUpdate } from 'svelte'
import BadgesView from './BadgesView.svelte'
import ShareUserWidget from './Sharing/ShareUserWidget.svelte'
import Spinner from './Spinner.svelte'

import { getContext } from 'svelte';
const { open } = getContext('simple-modal');
import ShareSheetModal from './Sharing/ShareSheetModal.svelte'

export let user
export let side


let feed = []
let inProgress = false
let latestTimestamp = Math.floor(Date.now() / 1000)
let currentUser
let userArea = false

let scrollTopId = null
let scrollTopValue = null

// Ugly workaround (Destroy as soon as possible)
function tryscrollToElem() {
    setTimeout(() => {
        if(scrollTopId) {
            let elem = document.getElementById(scrollTopId)
            if(elem) {
                elem.scrollIntoView()
                side.scrollTop = scrollTopValue
                scrollTopId = null
            } else {
                tryscrollToElem()
            }
        } else {
            tryscrollToElem()
        }
    }, 10)
}

onMount(async () => {
    let cachedFeedInfo = Common.getCachedFeed("user"+user.user_id)
    if(cachedFeedInfo) {
        console.log("Using cached user Feed")
        let info = JSON.parse(cachedFeedInfo)
        feed = info.feed
        latestTimestamp = feed[feed.length-1].data.createtime
        scrollTopId = info.itemId
        scrollTopValue = info.scrollTopValue
        Common.clearCachedFeed("user"+user.user_id)
        tryscrollToElem()
    } else {
        requestNextFeedItems()
    }

    let parentevent = side.onscroll
    side.onscroll = () => {
        parentevent()
        if((side.scrollHeight - (side.scrollTop + side.clientHeight)) < 800) {
            requestNextFeedItems()
        }
    }
})

const unsubsribe = Common.currentUser.subscribe(value => {
    currentUser = value
})

function reportUser() {
    if(!currentUser) {
        Common.loginContext.update(v => "user/" + user.user_id)
        push('/login')
        return;
    }

    let details = window.prompt("Please provide details as to why you are reporting this user:","Details go here.");
    if(details.length == 0) {
        return;
    }

    let report = {
        user_id : currentUser.user_id,
        type : Common.REPORTTYPE_USER,
        body : details,
        ref_id : user.user_id
    }

    Common.postData("report", report)
    .then(r => {
        if(r.ok) {
            alert("Sucessfully Reported User. Thank You.")
        } else {
            alert("Problem reporting. Please contact support.")
        }
    })
}

function requestNextFeedItems() {
    if(inProgress) {
        return
    }
    inProgress = true

    Common.getData('user/' + user.user_id + '/recent?seen=' + latestTimestamp)
    .then(data => {
        if(data === null) {
            return
        }
        console.log(data)
        if(feed.length==0) {
            feed = data;
        } else {
            feed = feed.concat(data)
        }

        if(feed.length!=0) {
            latestTimestamp = feed[feed.length-1].data.createtime
        }
        inProgress = false
    })
}

function showShareSheet() {
    open(ShareSheetModal, {
        link: "https://plantogether.city/user/" + user.user_id,
        shareString: user.user_name + "'s Profile on Plan Together"},
        {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

</script>

<svelte:head>
    <!-- Primary Meta Tags -->
    <title>{user.user_name + "'s Profile on Plan Together"}</title>
    <meta name="title" content={user.user_name + "'s Profile on Plan Together"}>
    <meta name="description" content={user.user_name + " is using the Plan Together Map to Collaboratively Discuss, Learn about and Contribute to their Community."}>

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content={"https://plantogether.city/user/" + user.user_id}>
    <meta property="og:title" content={user.user_name + "'s Profile on Plan Together"}>
    <meta property="og:description" content={user.user_name + " is using the Plan Together Map to Collaboratively Discuss, Learn about and Contribute to their Community."}>
    <!--<meta property="og:image" content={"API_URL/item-image/" + comment.item_id + ".png"}>-->

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content={"https://plantogether.city/user/" + user.user_id}>
    <meta property="twitter:title" content={user.user_name + "'s Profile on Plan Together"}>
    <meta property="twitter:description" content={user.user_name + " is using the Plan Together Map to Collaboratively Discuss, Learn about and Contribute to their Community."}>
    <!--<meta property="twitter:image" content={"API_URL/item-image/" + comment.item_id + ".png"}>-->
</svelte:head>

{#if user.user_area_id != 0}
    <div on:click={() => push('/area/' + user.user_area_id)}>
        <span class="badge">{user.user_area_name} Area Official</span>
    </div>
{/if}

{#if user.user_special != 0}
    <div>
        <span class="badge-special">{Common.getSpecialStr(user.user_special)}</span>
    </div>
{/if}

<div class="top">
    <h1>{user.user_name}</h1>

    <div class="user">
        {user.user_occupation}
        {#if user.user_location != ''}
        - {user.user_location}
        {/if}
    </div>

    <BadgesView item_count={user.user_itemcount} comment_count={user.user_commentcount} like_count={user.user_likecount}></BadgesView>

    <p>
        {user.user_bio}
    </p>

    <div class="new-controls">
        <div class="control-single" on:click={showShareSheet}>Share</div>
        <div class="control-single" on:click={reportUser}>Report</div>
    </div>

    <h3>Recent</h3>
</div>
{#if !inProgress && feed.length === 0}
<div>
    <p>
        No activity from this user.
    </p>
</div>
{:else}
    <FeedView includeNames={false} displayAreaLabels={false} {feed} feedName={"user"+user.user_id} {side}></FeedView>
    {#if inProgress}
        <Spinner></Spinner>
    {/if}
{/if}